import React, { useEffect, useState } from 'react';
import './HeaderFooter.css';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const NAV_ITEMS = [
  { id: 'demo', label: 'Démo' },
  { id: 'how', label: 'Comment ça marche' },
  { id: 'reviews', label: 'Avis' },
  { id: 'results', label: 'Résultats' },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [menuOpen]);

  const go = (id) => {
    setMenuOpen(false);
    scrollTo(id);
  };

  return (
    <header className={`hp-header ${scrolled ? 'is-scrolled' : ''} ${menuOpen ? 'is-menu-open' : ''}`}>
      <div className="hp-header-inner">
        <button type="button" className="hp-logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          HeyPulse
        </button>

        <nav className="hp-nav" aria-label="Navigation principale">
          {NAV_ITEMS.map((item) => (
            <button key={item.id} type="button" onClick={() => go(item.id)}>
              {item.label}
            </button>
          ))}
        </nav>

        <div className="hp-header-actions">
          <span className="hp-header-pill">15 jours offerts</span>
          <button type="button" className="hp-header-cta" onClick={() => go('create-game')}>
            <span className="hp-cta-full">Créer mon jeu gratuitement</span>
            <span className="hp-cta-short">Créer mon jeu</span>
          </button>
          <button
            type="button"
            className={`hp-menu-btn ${menuOpen ? 'is-open' : ''}`}
            aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
            aria-expanded={menuOpen}
            aria-controls="hp-mobile-nav"
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      <div id="hp-mobile-nav" className={`hp-mobile-panel ${menuOpen ? 'is-open' : ''}`}>
        <nav aria-label="Navigation mobile">
          {NAV_ITEMS.map((item) => (
            <button key={item.id} type="button" onClick={() => go(item.id)}>
              {item.label}
            </button>
          ))}
          <button type="button" className="hp-mobile-cta" onClick={() => go('create-game')}>
            Créer mon jeu gratuitement
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
